import { useNavigate } from 'react-router-dom';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function NoWarehouseAccessPage() {
  const navigate = useNavigate();

  return (
    <div
      className="flex h-[calc(100vh-8rem)] items-center justify-center"
      data-testid="no-warehouse-access-page"
    >
      <Card className="mx-auto max-w-md">
        <CardContent className="flex flex-col items-center gap-4 py-12 text-center">
          <div className="rounded-full bg-blue-500/10 p-4">
            <Info className="h-10 w-10 text-blue-500" />
          </div>

          <h2 className="text-2xl font-semibold">No Warehouse Access</h2>

          <p className="text-muted-foreground">
            You haven't been assigned to any warehouse yet. Please contact your
            administrator.
          </p>

          <Button className="mt-2" onClick={() => navigate('/')}>
            Go to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default NoWarehouseAccessPage;
